import { render } from "./AddPromoCode.vue?vue&type=template&id=4642343c"
import script from "./AddPromoCode.vue?vue&type=script&lang=js"
export * from "./AddPromoCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__